import React from 'react'

import { Button } from 'shared/components'

import classes from './AboutContract.module.scss'
import { useDistributionContext } from 'pages/Distribution/Distribution'

export const AboutContract = (): JSX.Element => {
  const { setPartnerFormOpened } = useDistributionContext()

  return (
    <div className="container reveal-from-bottom-medium" data-reveal-delay={50}>
      <h2 className={`${classes.title} second-title`}>
        ДОГОВОР О СОТРУДНИЧЕСТВЕ{'\n'}ВКЛЮЧАЕТ
      </h2>
      <div className="row">
        <div className="col-xs-12 col-sm-8">
          <p className={classes.info}>
            Нашим партнером могут стать юридические лица и индивидуальные
            предприниматели, зарегистрированные в РФ, желающие увеличить свой
            доход и лояльность клиентов. <br />
            <br />
            Работа с KION открывает перед авторизованными дилерами ряд
            возможностей и преимуществ:
            <br />
            <br />
          </p>
          <ul className={classes.list}>
            <li>
              надежное и прозрачное сотрудничество, рассчитанные на долгую
              перспективу;
            </li>
            <li>индивидуальный подход к каждому партнеру;</li>
            <li>
              доступ к заработку на динамично развивающемся рынке
              онлайн-кинотеатров.
            </li>
          </ul>
          <Button onClick={() => setPartnerFormOpened(true)}>
            Стать партнером
          </Button>
        </div>
      </div>
    </div>
  )
}
